export default __webpack_public_path__ + "static/media/clouds.525887c5.svg";